/**
* @Author: zachalam
* @Date:   2017-01-19T17:18:40-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T17:19:08-08:00
*/


import React, { Component } from 'react';
import MsgConvoScreen from '../components/pages/Mail/MsgConvoScreen';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { refreshConvo, postMail, deleteMail } from '../actions/mailActions';
import { toggleBlockInStore, toggleBlockProfile, refreshAccount } from '../actions/profileActions';
import Loader from 'react-loading-overlay';
import { color } from '../style';

class MsgConvoContainer extends Component {

  state = {
    lastUser: this.props.routeParams.username
  }

  componentWillMount() {
    // initial load
    this.props.refresh(this.props.routeParams.username);
    this.props.refreshAccount();
  }

  componentWillReceiveProps(nextProps) {
    let next = nextProps.routeParams.username;
    if(next != this.state.lastUser) {
      this.props.refresh(next);
      this.setState({lastUser: next});
    }
  }

  render() {
    return (
      <Loader active={this.props.convo.isFetching} spinner text={'Loading...'} color={color.BRAND_1} background="#fff" zindex={999}>
        <MsgConvoScreen {...this.props} />
      </Loader>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state);
  // Handle all the checks to protect against undefined variables in state.
  const profile = state.profile;
  const profileData = profile && profile.profile && profile.profile.data ? profile.profile.data : null;
  const isPremium = profile ? profile.is_premium : false;
  const isMale = profileData ? Boolean(profileData.sex === 'Male') : false;
  const isFemale = profileData ? Boolean(profileData.sex === 'Female') : false;
  const isEmailConfirmed = profile ? profile.email_confirmed : false;
  const isSpamFlagged = profile ? profile.is_spam_flagged : false;

  return {
    convo: state.convo,
    userId: profile ? profile.id : null,
    sex: profileData ? profileData.sex : null,
    myAvatar: profileData ? profileData.avatar.data.urls.profile : null,
    spamFlagged: isSpamFlagged,
    // users can message if are premium OR they are Female and have a confirmed email AND they are not spam flagged.
    canMsg: ( Boolean(isPremium && isMale) ||
      Boolean(isFemale && isEmailConfirmed) ) && !isSpamFlagged
  };
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    refresh: (username) => {
      // get conversation messages.
      dispatch(refreshConvo(username));
    },
    refreshAccount: () => {
      dispatch(refreshAccount());
    },
    submitMessage: (message) => {
      // submit new mail response to server.
      dispatch(postMail(ownProps.routeParams.username,message));
    },
    toggleBlock: (username) => {
      // notify api.
      dispatch(toggleBlockProfile(username))
            .then((resp) => {
              // redirect to block list.
              browserHistory.push("/blocked");
            });
    },
    deleteMail: (username) => {
      dispatch(deleteMail(username));
    }

  }
}

export default connect(mapStateToProps,mapDispatchToProps)(MsgConvoContainer);



// WEBPACK FOOTER //
// ./src/containers/MsgConvoContainer.jsx